module.exports = __webpack_public_path__ + "static/img/logo-businessline.32282912.svg";